import { useFieldArray, useFormContext } from 'react-hook-form';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Checkbox } from '@/components/ui/checkbox';
import { Textarea } from '@/components/ui/textarea';
import type { PlanFormData } from '../types';
import { GripVertical, Plus, X } from 'lucide-react';

export function PlanFeatures() {
  const { control } = useFormContext<PlanFormData>();
  const { fields, append, remove, } = useFieldArray({
    control,
    name: 'features'
  });

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">Features</h3>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => {
            append({
              id: crypto.randomUUID(),
              name: '',
              description: '',
              included: true,
              order: fields.length
            });
          }}
        >
          <Plus className="h-4 w-4 mr-2" />
          Add Feature
        </Button>
      </div>

      <div className="space-y-4">
        {fields.map((field, index) => (
          <div key={field.id} className="flex items-start gap-4 p-4 border rounded-lg">
            <Button
              type="button"
              variant="ghost"
              size="sm"
              className="cursor-move"
              onDragStart={(e) => {
                e.dataTransfer.setData('text/plain', index.toString());
              }}
              draggable
            >
              <GripVertical className="h-4 w-4" />
            </Button>

            <div className="flex-1 space-y-4">
              <Input
                {...control.register(`features.${index}.name`)}
                placeholder="Feature name"
              />
              <Textarea
                {...control.register(`features.${index}.description`)}
                placeholder="Feature description (optional)"
              />
              <div className="flex items-center gap-2">
                <Checkbox
                  {...control.register(`features.${index}.included`)}
                  id={`feature-included-${index}`}
                />
                <label htmlFor={`feature-included-${index}`}>
                  Included in plan
                </label>
              </div>
            </div>

            <Button
              type="button"
              variant="ghost"
              size="sm"
              onClick={() => remove(index)}
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
} 